import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}funcion`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}funcion/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}funcion/${id}`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}funcion`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}funcion`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}funcion/${id}`);
  return response;
};

const getParameter = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}funcion/parameters/${id}`);
  return response;
};

const getParameters = async (funcionId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}funcion/parameters/by/${funcionId}`);
  return response;
};

const insertParameter = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}funcion/parameters`, payload);
  return response;
};

const updateParameter = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}funcion/parameters`, payload);
  return response;
};

const dropParameter = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}funcion/parameters/${id}`);
  return response;
};

export { getAll, getList, getById, insert, update, drop, getParameter, getParameters, insertParameter, updateParameter, dropParameter };
